import React, { Component } from 'react';
import './Navbar.css';
import NavbarItem from './NavbarItem/NavbarItem.js'
import Logo from './Logo/Logo.js'

class Navbar extends Component {

  render() {
    return (
      <div className='Navbar'>
        <NavbarItem text="Portfolio" changePage={e => this.props.changePage(e, "home-portfolio")} />
        <NavbarItem text="About" changePage={this.props.changePage} />
        <Logo changePage={this.props.changePage} />
        <NavbarItem text="Press" changePage={this.props.changePage} />
        <NavbarItem text="Contact" changePage={this.props.changePage} />
      </div>
    )
  }
}

export default Navbar;
